<template>
  <cube class="cube-animation container"></cube>
</template>

<script>
import cubeAnimation from './components/cube-animation.vue'

export default {
  name: 'App',
  components: {
    cube:cubeAnimation
  }
}
</script>

<style>

body,html{
  font-family:'admun' ;
  margin: 0 auto;
  height: 100%;
}
p,h1,h2,h3,h4,h5,h6 {
  font-family: 'admun';
  margin: 0;
  font-weight: 400;

}
.container{

  width: 100%;
  height: 100%;
}
#app {
  font-family:'admun ';
  text-align: center;
  margin:0;
  height: inherit;
  width: inherit;
  overflow-x: hidden;
  overflow-y: hidden;
}
</style>
